// 表示は Asia/Tokyo（受信はUTC・[19] §5）。変換はこの共通関数のみを使う（散在させない）。
const TZ = "Asia/Tokyo";

export function formatDate(dateOnly: string): string {
  // "YYYY-MM-DD" はそのまま日本語表記に
  const [y, m, d] = dateOnly.split("-");
  if (!y || !m || !d) return dateOnly;
  return `${y}年${Number(m)}月${Number(d)}日`;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return "-";
  return new Date(iso).toLocaleString("ja-JP", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateRange(start: string, end: string): string {
  return start === end ? formatDate(start) : `${formatDate(start)} 〜 ${formatDate(end)}`;
}
